module.exports = __webpack_public_path__ + "img/empty02.1134bd51.svg";